import React, { FC, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../store/hooks/selector.hook";
import { getVendorsFetch } from "../../store/state/vendors/vendors.slice";
import { SYSTEM_ADMIN_ID } from "../../utl/constants/role";
import { culcPage } from "../../utl/helpers/culcPage";

function withLoadingVendors(Component: React.ComponentType) {
    const ComponentWithLoadingVendors: FC = () => {
        const dispatch = useAppDispatch();
        const page = useAppSelector(state => state.vendors.page, shallowEqual);
        const totalCount = useAppSelector(state => state.vendors.totalCount, shallowEqual);
        const pageAll = useAppSelector(state => state.vendors.pageAll, shallowEqual);
        const pageSize = useAppSelector(state => state.vendors.pageSize, shallowEqual);
        const getAllItems = useAppSelector(state => state.vendors.getAllItems, shallowEqual);
        const pagesRange = culcPage(page, pageAll, totalCount, pageSize);
        const roleId = useAppSelector(state => state.user.roleId, shallowEqual);

        useEffect(() => {
            if(roleId === SYSTEM_ADMIN_ID) {
                let filter = undefined;
                
                if(!getAllItems) {
                    filter = {
                        range: {
                            from: pagesRange.from,
                            to: pagesRange.to
                        }
                    }  
                }
        
                dispatch(getVendorsFetch({filter}));
            }
        }, [roleId]);

        return (
            <Component />
        );
    }

    return ComponentWithLoadingVendors;
}

export default withLoadingVendors;